import { VStack } from "@chakra-ui/react";
import { useUserContext } from "../../../Contexts/userContext";
import useThemeColors from "../../../hooks/useThemeColors";
import useIcons from "../../../hooks/useIcons";
import Cad from "../../CustomUi/Cad";
import SectionHeader from "../../CustomUi/SectionHeader";
import PromotionHistory from "./PromotionHistory";
import { useNavigate } from "react-router-dom";
import CustomAlert from "../../CustomUi/CustomAlert";

const Promotion: React.FC = () => {
  const { user } = useUserContext();
  const colors = useThemeColors();
  const icons = useIcons();
  const navigate = useNavigate();

  if (user?.role !== 3) {
    return (
      <CustomAlert
        title="Access Denied"
        message="Only administrators can manage student promotions."
      />
    );
  }

  return (
    <VStack gap={[2, 4]} align={"stretch"}>
      {/* Header with Eligibility Button */}
      <Cad h={"auto"} bg={colors.schoolAccent.primary} bgGradient="to-r" gradientFrom={colors.schoolAccent.tertiary} gradientTo={colors.schoolAccent.secondary}>
        <VStack gap={4} align="stretch">
          <SectionHeader
            reducedColors={true}
            title="Student Promotions"
            subtitle="Manage student promotions and track promotion history"
            icon={icons.people.students}
            buttonText="Check Eligibility"
            onButtonClick={() => navigate("/admin/promotion/eligibility")}
            buttonIcon={icons.main.promotion}
            buttonColorScheme={colors.schoolAccent.primary}
          />
        </VStack>
      </Cad>
      <PromotionHistory />
    </VStack>
  );
};

export default Promotion;
